<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">TABLE OF CONTENTS</h1>
<p class="crt1"><span class="hlink" href="#/tp" title="Link target outside of Sample">Title Page</span></p>
<p class="crt"><span class="hlink" href="#/cop" title="Link target outside of Sample">Copyright Page</span></p>
<p class="crt"><a class="hlink" href="#/ded">Dedication</a></p>
<p class="crt"><a class="hlink" href="#/ack">Acknowledgments</a></p>
<p class="crt1"><a class="hlink" href="#/prologue">Prologue</a></p>
<p class="crt"><a class="hlink" href="#/c01">Chapter 1</a></p>
<p class="crt"><a class="hlink" href="#/c02">Chapter 2</a></p>
<p class="crt"><a class="hlink" href="#/c03">Chapter 3</a></p>
<p class="crt"><span class="hlink" href="#/c04" title="Link target outside of Sample">Chapter 4</span></p>
<p class="crt"><span class="hlink" href="#/c05" title="Link target outside of Sample">Chapter 5</span></p>
<p class="crt"><span class="hlink" href="#/c06" title="Link target outside of Sample">Chapter 6</span></p>
<p class="crt"><span class="hlink" href="#/c07" title="Link target outside of Sample">Chapter 7</span></p>
<p class="crt"><span class="hlink" href="#/c08" title="Link target outside of Sample">Chapter 8</span></p>
<p class="crt"><span class="hlink" href="#/c09" title="Link target outside of Sample">Chapter 9</span></p>
<p class="crt"><span class="hlink" href="#/c10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="crt"><span class="hlink" href="#/c11" title="Link target outside of Sample">Chapter 11</span></p>
<p class="crt"><span class="hlink" href="#/c12" title="Link target outside of Sample">Chapter 12</span></p>
<p class="crt"><span class="hlink" href="#/c13" title="Link target outside of Sample">Chapter 13</span></p>
<p class="crt"><span class="hlink" href="#/c14" title="Link target outside of Sample">Chapter 14</span></p>
<p class="crt"><span class="hlink" href="#/c15" title="Link target outside of Sample">Chapter 15</span></p>
<p class="crt"><span class="hlink" href="#/c16" title="Link target outside of Sample">Chapter 16</span></p>
<p class="crt"><span class="hlink" href="#/c17" title="Link target outside of Sample">Chapter 17</span></p>
<p class="crt"><span class="hlink" href="#/c18" title="Link target outside of Sample">Chapter 18</span></p>
<p class="crt"><span class="hlink" href="#/c19" title="Link target outside of Sample">Chapter 19</span></p>
<p class="crt"><span class="hlink" href="#/c20" title="Link target outside of Sample">Chapter 20</span></p>
<p class="crt"><span class="hlink" href="#/c21" title="Link target outside of Sample">Chapter 21</span></p>
<p class="crt"><span class="hlink" href="#/c22" title="Link target outside of Sample">Chapter 22</span></p>
<p class="crt"><span class="hlink" href="#/c23" title="Link target outside of Sample">Chapter 23</span></p>
<p class="crt"><span class="hlink" href="#/c24" title="Link target outside of Sample">Chapter 24</span></p>
<p class="crt"><span class="hlink" href="#/c25" title="Link target outside of Sample">Chapter 25</span></p>
<p class="crt"><span class="hlink" href="#/c26" title="Link target outside of Sample">Chapter 26</span></p>
<p class="crt"><span class="hlink" href="#/c27" title="Link target outside of Sample">Chapter 27</span></p>
<p class="crt"><span class="hlink" href="#/c28" title="Link target outside of Sample">Chapter 28</span></p>
<p class="crt"><span class="hlink" href="#/c29" title="Link target outside of Sample">Chapter 29</span></p>
<p class="crt"><span class="hlink" href="#/c30" title="Link target outside of Sample">Chapter 30</span></p>
<p class="crt"><span class="hlink" href="#/c31" title="Link target outside of Sample">Chapter 31</span></p>
<p class="crt"><span class="hlink" href="#/c32" title="Link target outside of Sample">Chapter 32</span></p>
<p class="crt"><span class="hlink" href="#/c33" title="Link target outside of Sample">Chapter 33</span></p>
<p class="crt"><span class="hlink" href="#/c34" title="Link target outside of Sample">Chapter 34</span></p>
<p class="crt"><span class="hlink" href="#/c35" title="Link target outside of Sample">Chapter 35</span></p>
<p class="crt"><span class="hlink" href="#/c36" title="Link target outside of Sample">Chapter 36</span></p>
<p class="crt"><span class="hlink" href="#/c37" title="Link target outside of Sample">Chapter 37</span></p>
<p class="crt"><span class="hlink" href="#/epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="crt1"><span class="hlink" href="#/ata" title="Link target outside of Sample">About the Author</span></p>
<p class="crt"><span class="hlink" href="#/alsoby" title="Link target outside of Sample">Also by Elaine Viets</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2d574cec